export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6874.6b5b9fbf.jpg";